var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pos-r dash-swiper"},[_c('img',{staticStyle:{"width":"100%","height":"420px"},attrs:{"src":require("@/assets/imgs/banner2.png"),"alt":""}})])
}]

export { render, staticRenderFns }